export default __webpack_public_path__ + "static/gokwik-a1d795bc37b1379c10df85ca96657b02.svg";